<template>
    <v-container fluid class="overflow-auto pa-5">
        <v-form ref="form" :disabled="!record.userCanSave(authUser)" @input="$emit('input', $event)">
            <v-row dense>
                <v-col cols="12" lg="6">
                    <h4 class="mb-2">{{ $t('description') }}</h4>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" lg="7">
                    <!-- abstract: depending on the customer/setting, this is shown here, or below -->
                    <LabelField
                        v-if="showAbstract && globalParam('event.express.reverse_short_description_order')"
                        :label="$t('description_short_2')"
                        :label-tip="$t('event_description_short_2_placeholder')"
                    >
                        <v-textarea
                            :value="record.abstract"
                            dense
                            outlined
                            hide-details="auto"
                            counter="60"
                            :placeholder="$t('event_description_short_2_placeholder')"
                            :rules="[getRule('maxLength')(60)]"
                            :disabled="!record.canEditAbstract"
                            @input="onInput('abstract', $event)"
                        />
                    </LabelField>
                    <LabelField :label="$t('description_short')" :label-tip="$t('description_short_tip')">
                        <v-textarea
                            :value="record.summary_text"
                            dense
                            outlined
                            hide-details="auto"
                            :counter="globalParam('event.max_summary_text_chars', 200)"
                            :rules="[getRule('eventSummaryText')]"
                            :placeholder="$t('event_description_short_placeholder')"
                            @input="onInput('summary_text', $event)"
                        />
                    </LabelField>
                    <LabelField :label="$t('description_text')">
                        <TinymceEditor
                            :value="record.description"
                            :init="tmceConfig"
                            :placeholder="$t('event_description_placeholder')"
                            @input="onInput('description', $event)"
                        />
                    </LabelField>
                </v-col>
                <v-col cols="12" lg="5">
                    <LabelField
                        :label="$t('interessen_tags_erweiterte_suche')"
                        :label-tip="$t('interessen_tags_erweiterte_suche_tip')"
                    >
                        <TagSelect
                            :value="record.tags"
                            item-value="id"
                            for-event
                            :placeholder="$t('placeholder_event_description_tags')"
                            :show-add="userIsStaff()"
                            show-download
                            clearable
                            hide-details="auto"
                            @input="onInput('tags', $event)"
                        />
                    </LabelField>
                    <!-- abstract: depending on the customer/setting, this is shown here, or above -->
                    <LabelField
                        v-if="showAbstract && !globalParam('event.express.reverse_short_description_order')"
                        :label="$t('description_short_2')"
                        :label-tip="$t('event_description_short_2_placeholder')"
                    >
                        <v-textarea
                            :value="record.abstract"
                            dense
                            outlined
                            hide-details="auto"
                            counter="60"
                            :placeholder="$t('event_description_short_2_placeholder')"
                            :rules="[getRule('maxLength')(60)]"
                            :disabled="!record.canEditAbstract"
                            @input="onInput('abstract', $event)"
                        />
                    </LabelField>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
import { Event } from '@/models/Event';
import { globalParam } from '@/helpers/globals';
import getRulesMixin from '@/mixins/get-form-rules';
import { userIsStaff } from '@/helpers/auth';
import TagSelect from '@/components/tag/select';
import { mapState } from 'vuex';

export default {
    name: 'EventEditDescription',
    components: {
        TagSelect,
    },
    mixins: [getRulesMixin],

    props: {
        record: {
            type: Event,
            required: true,
        },
    },

    data() {
        return userIsStaff()
            ? {
                  // Config for staff users:
                  tmceConfig: {
                      toolbar1:
                          'link unlink | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | paste',
                      toolbar2: 'template | image media | code | fullscreen | undo redo',
                      body_id: 'agendaPage_get',
                      body_class: 'agenda mce-editor-body',
                      max_height: 500,
                  },
              }
            : {
                  // Config for non-staff (veranstalter) users:
                  tmceConfig: {
                      toolbar1: 'link unlink | bold italic | paste |code | fullscreen | undo redo',
                      toolbar2: null,
                      body_id: 'agendaPage_get',
                      body_class: 'agenda mce-editor-body',
                      paste_data_images: false,
                      paste_block_drop: false,
                      max_height: 500,
                  },
              };
    },

    computed: {
        ...mapState('user', {
            authUser: 'record',
        }),
        showAbstract() {
            if (this.globalParam('event.show_abstract_for_everyone')) {
                return true;
            }
            if (userIsStaff()) {
                return true;
            }
            return false;
        },
    },

    created() {
        this.globalParam = globalParam;
    },

    mounted() {
        this.validateForm();
    },

    methods: {
        userIsStaff,

        validateForm() {
            this.$refs.form.validate();
        },

        onInput(field, value) {
            this.record.set(field, value);
        },
    },
};
</script>

<style lang="scss" scoped></style>
